import { CoreTagsByIdName } from './name';
import { coreTagsRemoveSyncSlice } from '../remove';
import { deleteTag } from '@api';
import { removeTagReference } from '../_idMap/actions';
import { updateAllSonarObjectReferences } from '../../sonar-objects/_idMap/actions';

import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createDeleteAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreTagsByIdDeleteAsyncSlice = createDeleteAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.TAG_DELETED, (action) => ({
				sonarObjectTagId: action.data.id
			})),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) => coreTagsRemoveSyncSlice.syncActionCreator(request),
			(request) => removeTagReference(request),
			(request) =>
				updateAllSonarObjectReferences({
					tags: {
						toRemove: request.id
					}
				})
		]
	},
	name: CoreTagsByIdName,
	receive: false,
	request: true,
	requestHandler: deleteTag
});
